import {
  createContext,
  type Dispatch,
  type SetStateAction,
  useContext,
} from 'react';

const context = createContext<Dispatch<SetStateAction<boolean>> | undefined>(
  undefined
);

export function useModalContext() {
  const value = useContext(context);
  if (value === undefined) throw new Error('Use inside a modal');
  return value;
}

export default context.Provider;
